module.exports = __webpack_public_path__ + "img/omr.dc166875.png";